import { Inject, Injectable } from '@angular/core';
import { FacebookApiService } from '@vendasta/facebook';
import { FacebookPage, ListPagesForPartnerRequestInterface } from '@vendasta/facebook/lib/_internal';
import { Observable } from 'rxjs';
import { map, retry, switchMap } from 'rxjs/operators';

@Injectable()
export class FacebookPagePickerService {
  constructor(
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    private readonly facebookApiService: FacebookApiService,
  ) {}

  public readonly facebookPagesForPartner$: Observable<FacebookPage[]> = this.partnerId$.pipe(
    map((partnerId) => <ListPagesForPartnerRequestInterface>{ partnerId: partnerId }),
    switchMap((request) => this.facebookApiService.listPagesForPartner(request)),
    map((response) => response?.facebookPage),
    retry(1),
  );
}
